import { useState } from 'react';
import Layout from '../../../components/layout/Layout';

interface TransacaoContaDigital {
  id: number;
  data: string;
  hora: string;
  tipo: 'credito' | 'debito';
  categoria: 'deposito' | 'transferencia' | 'compra_pontos' | 'estorno' | 'taxa' | 'bonus';
  descricao: string;
  valor: number;
  saldoAnterior: number;
  saldoAtual: number;
  protocolo?: string;
  origem?: string;
  status: 'concluido' | 'pendente' | 'cancelado';
}

export default function ExtratoContaDigitalPage() {
  const [filtroTipo, setFiltroTipo] = useState('todos');
  const [filtroCategoria, setFiltroCategoria] = useState('todas');
  const [filtroPeriodo, setFiltroPeriodo] = useState('todos');
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const saldoAtual = 2450.00;

  const [transacoes] = useState<TransacaoContaDigital[]>([
    {
      id: 1,
      data: '2024-03-15',
      hora: '14:30:25',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito via TED - Banco Bradesco',
      valor: 1500.00,
      saldoAnterior: 950.00,
      saldoAtual: 2450.00,
      protocolo: 'DEP-2024-001234',
      origem: 'TED Bradesco Ag. 3263',
      status: 'concluido'
    },
    {
      id: 2,
      data: '2024-03-14',
      hora: '16:45:12',
      tipo: 'debito',
      categoria: 'compra_pontos',
      descricao: 'Compra de pontos de incentivo - Pacote Premium',
      valor: 800.00,
      saldoAnterior: 1750.00,
      saldoAtual: 950.00,
      protocolo: 'CPT-2024-005678',
      status: 'concluido'
    },
    {
      id: 3,
      data: '2024-03-13',
      hora: '09:15:33',
      tipo: 'credito',
      categoria: 'bonus',
      descricao: 'Bônus de boas-vindas - Programa de Incentivos',
      valor: 250.00,
      saldoAnterior: 1500.00,
      saldoAtual: 1750.00,
      protocolo: 'BON-2024-001122',
      status: 'concluido'
    },
    {
      id: 4,
      data: '2024-03-12',
      hora: '11:20:45',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito via Boleto Bancário',
      valor: 1000.00,
      saldoAnterior: 500.00,
      saldoAtual: 1500.00,
      protocolo: 'DEP-2024-001123',
      origem: 'Boleto Bradesco',
      status: 'concluido'
    },
    {
      id: 5,
      data: '2024-03-11',
      hora: '15:30:18',
      tipo: 'debito',
      categoria: 'compra_pontos',
      descricao: 'Compra de pontos de incentivo - Pacote Básico',
      valor: 300.00,
      saldoAnterior: 800.00,
      saldoAtual: 500.00,
      protocolo: 'CPT-2024-005679',
      status: 'concluido'
    },
    {
      id: 6,
      data: '2024-03-10',
      hora: '13:45:22',
      tipo: 'credito',
      categoria: 'estorno',
      descricao: 'Estorno de compra cancelada',
      valor: 150.00,
      saldoAnterior: 650.00,
      saldoAtual: 800.00,
      protocolo: 'EST-2024-000456',
      status: 'concluido'
    },
    {
      id: 7,
      data: '2024-03-09',
      hora: '10:12:55',
      tipo: 'debito',
      categoria: 'taxa',
      descricao: 'Taxa de manutenção mensal',
      valor: 12.90,
      saldoAnterior: 662.90,
      saldoAtual: 650.00,
      protocolo: 'TAX-2024-000789',
      status: 'concluido'
    },
    {
      id: 8,
      data: '2024-03-08',
      hora: '08:30:10',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito via PIX',
      valor: 500.00,
      saldoAnterior: 162.90,
      saldoAtual: 662.90,
      protocolo: 'DEP-2024-001124',
      origem: 'PIX Chave Email',
      status: 'concluido'
    },
    {
      id: 9,
      data: '2024-03-07',
      hora: '17:22:33',
      tipo: 'debito',
      categoria: 'compra_pontos',
      descricao: 'Compra de pontos de incentivo - Pacote Intermediário',
      valor: 500.00,
      saldoAnterior: 662.90,
      saldoAtual: 162.90,
      protocolo: 'CPT-2024-005680',
      status: 'concluido'
    },
    {
      id: 10,
      data: '2024-03-06',
      hora: '12:15:44',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito inicial - Abertura de conta',
      valor: 662.90,
      saldoAnterior: 0.00,
      saldoAtual: 662.90,
      protocolo: 'DEP-2024-001125',
      origem: 'Transferência Inicial',
      status: 'concluido'
    },
    {
      id: 11,
      data: '2024-02-29',
      hora: '14:22:10',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito via PIX - Chave CPF',
      valor: 2500.00,
      saldoAnterior: 1200.00,
      saldoAtual: 3700.00,
      protocolo: 'DEP-2024-001126',
      origem: 'PIX Chave CPF',
      status: 'concluido'
    },
    {
      id: 12,
      data: '2024-02-28',
      hora: '09:45:33',
      tipo: 'debito',
      categoria: 'compra_pontos',
      descricao: 'Compra de pontos de incentivo - Pacote Empresarial',
      valor: 1200.00,
      saldoAnterior: 2400.00,
      saldoAtual: 1200.00,
      protocolo: 'CPT-2024-005681',
      status: 'concluido'
    },
    {
      id: 13,
      data: '2024-02-27',
      hora: '16:30:55',
      tipo: 'credito',
      categoria: 'bonus',
      descricao: 'Bônus por indicação de novo cliente',
      valor: 500.00,
      saldoAnterior: 1900.00,
      saldoAtual: 2400.00,
      protocolo: 'BON-2024-001123',
      status: 'concluido'
    },
    {
      id: 14,
      data: '2024-02-26',
      hora: '11:15:20',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito via TED - Banco Itaú',
      valor: 3000.00,
      saldoAnterior: -1100.00,
      saldoAtual: 1900.00,
      protocolo: 'DEP-2024-001127',
      origem: 'TED Itaú Ag. 0456',
      status: 'concluido'
    },
    {
      id: 15,
      data: '2024-02-25',
      hora: '13:50:45',
      tipo: 'debito',
      categoria: 'compra_pontos',
      descricao: 'Compra de pontos de incentivo - Pacote Gold',
      valor: 1500.00,
      saldoAnterior: 400.00,
      saldoAtual: -1100.00,
      protocolo: 'CPT-2024-005682',
      status: 'concluido'
    },
    {
      id: 16,
      data: '2024-02-24',
      hora: '10:25:12',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito via Boleto Bancário',
      valor: 1800.00,
      saldoAnterior: -1400.00,
      saldoAtual: 400.00,
      protocolo: 'DEP-2024-001128',
      origem: 'Boleto Santander',
      status: 'concluido'
    },
    {
      id: 17,
      data: '2024-02-23',
      hora: '15:40:30',
      tipo: 'debito',
      categoria: 'taxa',
      descricao: 'Taxa de processamento de transação',
      valor: 8.50,
      saldoAnterior: -1391.50,
      saldoAtual: -1400.00,
      protocolo: 'TAX-2024-000790',
      status: 'concluido'
    },
    {
      id: 18,
      data: '2024-02-22',
      hora: '09:20:15',
      tipo: 'credito',
      categoria: 'estorno',
      descricao: 'Estorno de taxa cobrada indevidamente',
      valor: 25.00,
      saldoAnterior: -1416.50,
      saldoAtual: -1391.50,
      protocolo: 'EST-2024-000457',
      status: 'concluido'
    },
    {
      id: 19,
      data: '2024-02-21',
      hora: '14:10:40',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito via PIX - Chave Telefone',
      valor: 750.00,
      saldoAnterior: -2166.50,
      saldoAtual: -1416.50,
      protocolo: 'DEP-2024-001129',
      origem: 'PIX Chave Telefone',
      status: 'concluido'
    },
    {
      id: 20,
      data: '2024-02-20',
      hora: '11:55:25',
      tipo: 'debito',
      categoria: 'compra_pontos',
      descricao: 'Compra de pontos de incentivo - Pacote Platinum',
      valor: 2000.00,
      saldoAnterior: -166.50,
      saldoAtual: -2166.50,
      protocolo: 'CPT-2024-005683',
      status: 'concluido'
    },
    {
      id: 21,
      data: '2024-02-19',
      hora: '16:35:50',
      tipo: 'credito',
      categoria: 'bonus',
      descricao: 'Bônus de aniversário da conta',
      valor: 300.00,
      saldoAnterior: -466.50,
      saldoAtual: -166.50,
      protocolo: 'BON-2024-001124',
      status: 'concluido'
    },
    {
      id: 22,
      data: '2024-02-18',
      hora: '08:45:15',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito via TED - Banco Caixa',
      valor: 1200.00,
      saldoAnterior: -1666.50,
      saldoAtual: -466.50,
      protocolo: 'DEP-2024-001130',
      origem: 'TED Caixa Ag. 1234',
      status: 'concluido'
    },
    {
      id: 23,
      data: '2024-02-17',
      hora: '13:20:40',
      tipo: 'debito',
      categoria: 'compra_pontos',
      descricao: 'Compra de pontos de incentivo - Pacote Starter',
      valor: 450.00,
      saldoAnterior: -1216.50,
      saldoAtual: -1666.50,
      protocolo: 'CPT-2024-005684',
      status: 'concluido'
    },
    {
      id: 24,
      data: '2024-02-16',
      hora: '10:15:30',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito via PIX - Chave Aleatória',
      valor: 900.00,
      saldoAnterior: -2116.50,
      saldoAtual: -1216.50,
      protocolo: 'DEP-2024-001131',
      origem: 'PIX Chave Aleatória',
      status: 'concluido'
    },
    {
      id: 25,
      data: '2024-02-15',
      hora: '15:50:20',
      tipo: 'debito',
      categoria: 'taxa',
      descricao: 'Taxa de manutenção mensal',
      valor: 12.90,
      saldoAnterior: -2103.60,
      saldoAtual: -2116.50,
      protocolo: 'TAX-2024-000791',
      status: 'concluido'
    },
    {
      id: 26,
      data: '2024-02-14',
      hora: '09:30:45',
      tipo: 'credito',
      categoria: 'estorno',
      descricao: 'Estorno de compra não processada',
      valor: 680.00,
      saldoAnterior: -2783.60,
      saldoAtual: -2103.60,
      protocolo: 'EST-2024-000458',
      status: 'concluido'
    },
    {
      id: 27,
      data: '2024-02-13',
      hora: '14:25:10',
      tipo: 'credito',
      categoria: 'bonus',
      descricao: 'Bônus por atingir meta trimestral',
      valor: 1000.00,
      saldoAnterior: -3783.60,
      saldoAtual: -2783.60,
      protocolo: 'BON-2024-001125',
      status: 'concluido'
    },
    {
      id: 28,
      data: '2024-02-12',
      hora: '11:40:35',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito via Boleto Bancário',
      valor: 2500.00,
      saldoAnterior: -6283.60,
      saldoAtual: -3783.60,
      protocolo: 'DEP-2024-001132',
      origem: 'Boleto Banco do Brasil',
      status: 'concluido'
    },
    {
      id: 29,
      data: '2024-02-11',
      hora: '16:15:50',
      tipo: 'debito',
      categoria: 'compra_pontos',
      descricao: 'Compra de pontos de incentivo - Pacote Mega',
      valor: 3500.00,
      saldoAnterior: -2783.60,
      saldoAtual: -6283.60,
      protocolo: 'CPT-2024-005685',
      status: 'concluido'
    },
    {
      id: 30,
      data: '2024-02-10',
      hora: '08:55:25',
      tipo: 'credito',
      categoria: 'deposito',
      descricao: 'Depósito via TED - Banco Santander',
      valor: 1800.00,
      saldoAnterior: -4583.60,
      saldoAtual: -2783.60,
      protocolo: 'DEP-2024-001133',
      origem: 'TED Santander Ag. 2345',
      status: 'concluido'
    }
  ]);

  const filteredTransacoes = transacoes.filter(t => {
    const matchesSearch = t.descricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         t.protocolo?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesTipo = filtroTipo === 'todos' || t.tipo === filtroTipo;
    const matchesCategoria = filtroCategoria === 'todas' || t.categoria === filtroCategoria;
    
    // Filtro de período
    const dataTransacao = new Date(t.data);
    const hoje = new Date();
    let matchesPeriodo = true;
    
    if (filtroPeriodo === 'todos') {
      matchesPeriodo = true;
    } else if (filtroPeriodo === '7dias') {
      const seteDiasAtras = new Date(hoje.getTime() - 7 * 24 * 60 * 60 * 1000);
      matchesPeriodo = dataTransacao >= seteDiasAtras;
    } else if (filtroPeriodo === '30dias') {
      const trintaDiasAtras = new Date(hoje.getTime() - 30 * 24 * 60 * 60 * 1000);
      matchesPeriodo = dataTransacao >= trintaDiasAtras;
    } else if (filtroPeriodo === '90dias') {
      const noventaDiasAtras = new Date(hoje.getTime() - 90 * 24 * 60 * 60 * 1000);
      matchesPeriodo = dataTransacao >= noventaDiasAtras;
    } else if (filtroPeriodo === 'personalizado' && dataInicio && dataFim) {
      const inicio = new Date(dataInicio);
      const fim = new Date(dataFim);
      matchesPeriodo = dataTransacao >= inicio && dataTransacao <= fim;
    }
    
    return matchesSearch && matchesTipo && matchesCategoria && matchesPeriodo;
  });

  const getTipoColor = (tipo: string) => {
    return tipo === 'credito' ? 'text-emerald-600' : 'text-red-600';
  };

  const getTipoIcon = (tipo: string) => {
    return tipo === 'credito' ? 'ri-arrow-up-line' : 'ri-arrow-down-line';
  };

  const getCategoriaIcon = (categoria: string) => {
    const icons = {
      'deposito': 'ri-bank-line',
      'transferencia': 'ri-exchange-line',
      'compra_pontos': 'ri-coin-line',
      'estorno': 'ri-refund-line',
      'taxa': 'ri-file-list-line',
      'bonus': 'ri-gift-line'
    };
    return icons[categoria as keyof typeof icons] || 'ri-money-dollar-circle-line';
  };

  const getCategoriaColor = (categoria: string) => {
    const colors = {
      'deposito': 'bg-emerald-100 text-emerald-800',
      'transferencia': 'bg-blue-100 text-blue-800',
      'compra_pontos': 'bg-orange-100 text-orange-800',
      'estorno': 'bg-purple-100 text-purple-800',
      'taxa': 'bg-red-100 text-red-800',
      'bonus': 'bg-green-100 text-green-800'
    };
    return colors[categoria as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  const getCategoriaLabel = (categoria: string) => {
    const labels = {
      'deposito': 'Depósito',
      'transferencia': 'Transferência',
      'compra_pontos': 'Compra de Pontos',
      'estorno': 'Estorno',
      'taxa': 'Taxa',
      'bonus': 'Bônus'
    };
    return labels[categoria as keyof typeof labels] || categoria;
  };

  const getStatusColor = (status: string) => {
    const colors = {
      'concluido': 'bg-emerald-100 text-emerald-800',
      'pendente': 'bg-yellow-100 text-yellow-800',
      'cancelado': 'bg-red-100 text-red-800'
    };
    return colors[status as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  const getStatusLabel = (status: string) => {
    const labels = {
      'concluido': 'Concluído',
      'pendente': 'Pendente',
      'cancelado': 'Cancelado'
    };
    return labels[status as keyof typeof labels] || status;
  };

  const totalCreditos = filteredTransacoes
    .filter(t => t.tipo === 'credito')
    .reduce((sum, t) => sum + t.valor, 0);

  const totalDebitos = filteredTransacoes
    .filter(t => t.tipo === 'debito')
    .reduce((sum, t) => sum + t.valor, 0);

  const exportarExtrato = () => {
    // Simular exportação
    const csvContent = 'data,hora,tipo,categoria,descricao,valor,saldo_anterior,saldo_atual,protocolo,status\\n' +
      filteredTransacoes.map(t => 
        `${t.data},${t.hora},${t.tipo},${t.categoria},"${t.descricao}",${t.valor},${t.saldoAnterior},${t.saldoAtual},${t.protocolo || ''},${t.status}`
      ).join('\\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `extrato_conta_digital_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center space-x-2 mb-2">
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/admin')}
                className="text-blue-600 hover:text-blue-800 cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-left-line"></i>
                </div>
              </button>
              <span className="text-sm text-gray-500">Dashboard</span>
              <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
              <span className="text-sm text-gray-900">Extrato Conta Digital</span>
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Extrato da Conta Digital</h1>
            <p className="text-gray-600 mt-1">Histórico completo de movimentações financeiras</p>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={exportarExtrato}
              className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-download-line"></i>
              </div>
              <span>Exportar</span>
            </button>
          </div>
        </div>

        {/* Resumo */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Saldo Atual</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">
                  R$ {saldoAtual.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-blue-600 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-wallet-3-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total de Créditos</p>
                <p className="text-2xl font-bold text-emerald-600 mt-2">
                  R$ {totalCreditos.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-emerald-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-arrow-up-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total de Débitos</p>
                <p className="text-2xl font-bold text-red-600 mt-2">
                  R$ {totalDebitos.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-red-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Transações</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">{filteredTransacoes.length}</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-purple-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-file-list-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filtros */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-gray-400"></i>
                </div>
              </div>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm w-full"
                placeholder="Buscar transações..."
              />
            </div>
            
            <select
              value={filtroTipo}
              onChange={(e) => setFiltroTipo(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
            >
              <option value="todos">Todos os Tipos</option>
              <option value="credito">Créditos</option>
              <option value="debito">Débitos</option>
            </select>

            <select
              value={filtroCategoria}
              onChange={(e) => setFiltroCategoria(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
            >
              <option value="todas">Todas as Categorias</option>
              <option value="deposito">Depósitos</option>
              <option value="compra_pontos">Compra de Pontos</option>
              <option value="bonus">Bônus</option>
              <option value="estorno">Estornos</option>
              <option value="taxa">Taxas</option>
            </select>

            <select
              value={filtroPeriodo}
              onChange={(e) => setFiltroPeriodo(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
            >
              <option value="todos">Todos os períodos</option>
              <option value="7dias">Últimos 7 dias</option>
              <option value="30dias">Últimos 30 dias</option>
              <option value="90dias">Últimos 90 dias</option>
              <option value="personalizado">Período personalizado</option>
            </select>

            {filtroPeriodo === 'personalizado' && (
              <>
                <input
                  type="date"
                  value={dataInicio}
                  onChange={(e) => setDataInicio(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                />
                <input
                  type="date"
                  value={dataFim}
                  onChange={(e) => setDataFim(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                />
              </>
            )}
          </div>
        </div>

        {/* Tabela de Transações */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Data/Hora
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Descrição
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Categoria
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Valor
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Saldo
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredTransacoes.map((transacao) => (
                  <tr key={transacao.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {new Date(transacao.data).toLocaleDateString('pt-BR')}
                      </div>
                      <div className="text-xs text-gray-500">{transacao.hora}</div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm font-medium text-gray-900">{transacao.descricao}</div>
                      {transacao.origem && (
                        <div className="text-xs text-gray-500 mt-1">{transacao.origem}</div>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getCategoriaColor(transacao.categoria)}`}>
                        {getCategoriaLabel(transacao.categoria)}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right">
                      <span className={`text-sm font-bold ${transacao.tipo === 'credito' ? 'text-emerald-600' : 'text-red-600'}`}>
                        {transacao.tipo === 'credito' ? '+' : '-'} R$ {transacao.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      </span>
                      <div className="text-xs text-gray-500 mt-1">
                        {transacao.tipo === 'credito' ? 'Creditado' : 'Debitado'}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-gray-900">
                      R$ {transacao.saldoAtual.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {filteredTransacoes.length === 0 && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center">
            <div className="w-16 h-16 mx-auto bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-file-list-line text-gray-400 text-2xl"></i>
              </div>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhuma transação encontrada</h3>
            <p className="text-gray-500">Tente ajustar os filtros para encontrar as transações desejadas.</p>
          </div>
        )}
      </div>
    </Layout>
  );
}
